export default {
      id: "bluetooth-icon-90-usage",
      viewBox: "0 0 32 28",
      url: __webpack_public_path__ + "img/icons.svg#bluetooth-icon-90",
      toString: function () {
        return this.url;
      }
    }